import React from 'react';
import { Box, BoxProps } from '@chakra-ui/react';
import { useDrop } from 'react-dnd';
import { ContentBoxItem, ItemTypes } from '../dnd/types';
import { colors } from '../../../../../../App/ChakraTheme';
import ContentBox, { ContentBoxPreview } from '../dnd/ContentDrag';

interface SlotProps extends BoxProps {
  id: string;
  type?: 'text' | 'image' | 'audio';
  value?: string;
  updateValue: (
    toKey: string,
    newValue: string,
    fromKey: string,
    type: 'text' | 'image' | 'audio',
  ) => void;
  placeholder?: any;
  slot?: string;
}

const Slot: React.FC<SlotProps> = ({
  id,
  value,
  updateValue,
  slot,
  type,
  placeholder,
  ...rest
}) => {
  const [{ highlight }, dropRef] = useDrop(
    () => ({
      accept: ItemTypes.ContentBox,
      drop: (item: ContentBoxItem, monitor) => {
        updateValue(id, item.src, item.id, item.type);
      },
      collect: (monitor) => ({
        highlight: monitor.isOver(),
      }),
    }),
    [],
  );

  return (
    <Box
      minW={value ? undefined : '128px'}
      minH={value ? undefined : '32px'}
      w="fit-content"
      border="1px"
      borderRadius="8px"
      borderColor="gray.500"
      color="blue.500"
      background={
        highlight ? colors.applyOpacity(colors.darkblue, 0.35) : 'white'
      }
      display="inline-flex"
      {...rest}
      ref={dropRef}
    >
      {value && type ? (
        <ContentBox
          id={slot}
          background={
            highlight ? colors.applyOpacity(colors.darkblue, 0.35) : 'white'
          }
          type={type}
          src={value}
        />
      ) : placeholder ? (
        <ContentBoxPreview
          opacity={0.5}
          type={placeholder.type}
          src={placeholder.src}
        >
          {placeholder}
        </ContentBoxPreview>
      ) : null}
    </Box>
  );
};

export { Slot };
export default Slot;
